import { render, staticRenderFns } from "./MatchHoldStep.vue?vue&type=template&id=67451bd0"
import script from "./MatchHoldStep.vue?vue&type=script&lang=js"
export * from "./MatchHoldStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports